import { render, staticRenderFns } from "./IcoMenuTemplate.vue?vue&type=template&id=27f8d065&lang=html"
import script from "./IcoMenuTemplate.vue?vue&type=script&lang=js"
export * from "./IcoMenuTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports